// import sample from "https://icseindia.org/document/sample.pdf";

// Type definitions for the download object
export interface PDFDownloadType {
  id: number;
  title: string;
  src: string;
  dateUploaded: string;
}

// Array of sample PDFs for download
export const samplePDFDownloads: PDFDownloadType[] = [
  {
    id: 1,
    title: "Curriculum Vitae",
    src: "https://s24.q4cdn.com/216390268/files/doc_downloads/test.pdf",
    dateUploaded: "13-04-2024"
  },
  {
    id: 2,
    title: "Resume",
    src: "https://s24.q4cdn.com/216390268/files/doc_downloads/test.pdf",
    dateUploaded: "11-10-2025"
  },
  {
    id: 3,
    title: "Portfolio",
    src: "https://s24.q4cdn.com/216390268/files/doc_downloads/test.pdf",
    dateUploaded: "28-02-2025"
  },
]
